module.exports = __webpack_public_path__ + "img/material1004.e7886882.png";